import { busService } from "../../bus";
import { ScriptHistoryEventMessage } from "../../../messages/scripting/ScriptMessages";
const busConnection = busService.connection("ScriptHistoryService");
export class ScriptHistoryService {
    static log(params) {
        busConnection.send(new ScriptHistoryEventMessage(params));
    }
}
